<template>
  <el-table-column
    prop="other_tool.name"
    sortable="custom"
    label="Egyéb eszközök köre"
    show-overflow-tooltip
    min-width="200"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.other_tool">{{ scope.row.other_tool.name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'other_tool.name',
  };
</script>
